import { useEffect, useState } from "react";
import { MessageSquareQuote, Check, Trash2 } from "lucide-react";
import { api, fmtError } from "../lib/api";
import { toast } from "sonner";
import { Stars } from "./Reviews";

export const AdminReviews = () => {
  const [reviews, setReviews] = useState(null);

  const load = () => {
    api.get("/admin/reviews").then((r) => setReviews(r.data)).catch(() => setReviews([]));
  };
  useEffect(load, []);

  if (!reviews) return null;

  const moderate = async (r, action) => {
    try {
      await api.post("/admin/reviews/moderate", { review_id: r.review_id, action });
      toast.success(action === "approve" ? "Avis publié" : "Avis supprimé");
      load();
    } catch (e) {
      toast.error(fmtError(e));
    }
  };

  const pending = reviews.filter((r) => !r.approved);
  const published = reviews.filter((r) => r.approved);

  const Row = ({ r }) => (
    <div className="flex flex-wrap items-start gap-3 border border-white/[0.06] p-4" data-testid={`review-row-${r.review_id}`}>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-3">
          <Stars value={r.rating} />
          <span className="text-xs text-zinc-500">{r.track_title} — {r.user_name || "Acheteur"}</span>
        </div>
        {r.comment && <p className="mt-2 text-xs leading-relaxed text-zinc-400">{r.comment}</p>}
      </div>
      {!r.approved && (
        <button
          onClick={() => moderate(r, "approve")}
          data-testid={`approve-review-${r.review_id}`}
          className="flex items-center gap-1.5 border border-emerald-500/50 px-3 py-1.5 text-[10px] uppercase tracking-[0.15em] text-emerald-400 transition-colors hover:bg-emerald-500 hover:text-black"
        >
          <Check className="h-3.5 w-3.5" /> Publier
        </button>
      )}
      <button
        onClick={() => moderate(r, "delete")}
        data-testid={`delete-review-${r.review_id}`}
        className="flex items-center gap-1.5 border border-red-500/40 px-3 py-1.5 text-[10px] uppercase tracking-[0.15em] text-red-400 transition-colors hover:bg-red-500 hover:text-black"
      >
        <Trash2 className="h-3.5 w-3.5" /> Supprimer
      </button>
    </div>
  );

  return (
    <section className="border border-white/[0.08] bg-surface p-8" data-testid="admin-reviews">
      <h2 className="flex items-center gap-3 font-display text-2xl font-medium">
        <MessageSquareQuote className="h-5 w-5 text-amber-500" /> Modération des avis
      </h2>
      <p className="mt-2 text-xs text-zinc-500">
        Les avis ne sont visibles publiquement qu'après votre publication.
      </p>
      {pending.length > 0 && (
        <div className="mt-5">
          <p className="text-xs uppercase tracking-[0.25em] text-amber-500">En attente ({pending.length})</p>
          <div className="mt-3 space-y-2" data-testid="reviews-pending">
            {pending.map((r) => <Row key={r.review_id} r={r} />)}
          </div>
        </div>
      )}
      <div className="mt-5">
        <p className="text-xs uppercase tracking-[0.25em] text-zinc-500">Publiés ({published.length})</p>
        <div className="mt-3 space-y-2" data-testid="reviews-published">
          {published.length === 0 && <p className="text-sm text-zinc-600">Aucun avis publié pour le moment.</p>}
          {published.map((r) => <Row key={r.review_id} r={r} />)}
        </div>
      </div>
      {reviews.length === 0 && (
        <p className="mt-5 text-sm text-zinc-500" data-testid="reviews-empty">Aucun avis pour le moment.</p>
      )}
    </section>
  );
};
